
export function roundInteractiveInput(num) {
  return num.toFixed(3)
}